$(document).ready(function() {
  var orangeBar     = $('#orange-bar').innerHeight();
  var pageContainer = $('#oc-container');
  var navWrapper    = $('#nav');
  var ocIcon        = $('#oc-icon');
  var ocUtil        = $('#oc-utility');

  pageContainer.css('top', orangeBar + 'px');
  // navWrapper.css('top', orangeBar + 'px'); default
  ocIcon.css('top', (orangeBar + 17) + 'px');
  ocUtil.css('top', orangeBar + 'px');

  /*----------  Off Canvas Utilities  ----------*/
  $('#oc-icon').stop().click(function() {
    $('.oc-js').toggleClass('active');
    $('.nav-bars').toggleClass('m-nav-open');
    $('#orange-bar').toggleClass('');
  });

  $('#oc-icon').stop().on('keydown', function(event) {
    if (event.which === 13) {
      $('.oc-js').toggleClass('active');
      $('.nav-bars').toggleClass('m-nav-open');
      $('#orange-bar').toggleClass('');
      $('.m-nav .first-lvl').first().find('>a').focus();

      document.addEventListener('focusin', onFocus);

      function onFocus(e) {
        if(!$('.m-nav').find(e.target).length) {
          $('.oc-js').toggleClass('active');
          $('.nav-bars').toggleClass('m-nav-open');
          $('#orange-bar').toggleClass('');
          document.removeEventListener('focusin', onFocus);
        }
      }
    }
  });

  $('span.oc-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).next('ul').stop().slideToggle();
    if ($(this).hasClass('plus')) {
      $(this).stop().removeClass('plus').addClass('minus');
      
    } else {
      $(this).stop().removeClass('minus').addClass('plus');
      
    }
  });

  $('span.oc-toggle').on('keydown', function(event) {
    if (event.which === 13) {
      $(this).next('ul').stop().slideToggle();
      if ($(this).hasClass('plus')) {
        $(this).stop().removeClass('plus').addClass('minus');
      } else {
        $(this).stop().removeClass('minus').addClass('plus');
      }
    }
  });

  var desktopItems = $('#nav .d-nav > .first-lvl');
  var desktopLinks = desktopItems.children('a');

  function closeDesktopMenus(exceptItem) {
    desktopItems.each(function() {
      if (exceptItem && this === exceptItem) return;
      $(this).removeClass('focus');
      $(this).children('a[aria-expanded]').attr('aria-expanded', 'false');
    });
  }

  $('#nav .d-nav').on('focusin', '.first-lvl', function() {
    closeDesktopMenus(this);
    $(this).addClass('focus');
    $(this).children('a[aria-expanded]').attr('aria-expanded', 'true');
  });

  $('#nav .d-nav').on('focusout', '.first-lvl', function() {
    var item = this;
    window.setTimeout(function() {
      if (!item.contains(document.activeElement)) {
        $(item).removeClass('focus');
        $(item).children('a[aria-expanded]').attr('aria-expanded', 'false');
      }
    }, 0);
  });

  desktopLinks.on('keydown', function(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Escape') return;

    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Escape') {
      closeDesktopMenus();
      this.focus();
      return;
    }

    var currentIndex = desktopLinks.index(this);
    var direction = event.key === 'ArrowLeft' ? -1 : 1;
    var targetIndex = (currentIndex + direction + desktopLinks.length) % desktopLinks.length;
    var target = desktopLinks.get(targetIndex);

    closeDesktopMenus(target.parentNode);
    target.focus();
  });

  function updateMobileNavigationTabStops() {
    if (window.innerWidth >= 768) return;

    var mobileNavIsOpen = navWrapper.hasClass('active');
    $('#nav .m-nav').find('a, button, [tabindex]').each(function() {
      var element = $(this);
      if (mobileNavIsOpen) {
        if (element.attr('data-closed-tabindex') !== undefined) {
          var originalTabindex = element.attr('data-closed-tabindex');
          if (originalTabindex === '') element.removeAttr('tabindex');
          else element.attr('tabindex', originalTabindex);
          element.removeAttr('data-closed-tabindex');
        }
      } else {
        if (element.attr('data-closed-tabindex') === undefined) {
          element.attr('data-closed-tabindex', element.attr('tabindex') || '');
        }
        element.attr('tabindex', '-1');
      }
    });
  }

  updateMobileNavigationTabStops();
  $(document).on('header:mobile-state', updateMobileNavigationTabStops);
  $('#oc-icon').on('click keydown', function(event) {
    if (event.type === 'keydown' && event.which !== 13 && event.which !== 32) return;
    window.setTimeout(updateMobileNavigationTabStops, 0);
  });
});


/**
 *
 * Window Resize Functions
 *
 **/

$(window).resize(function() {
  var orangeBar     = $('#orange-bar').innerHeight();
  var pageContainer = $('#oc-container');
  var navWrapper    = $('#nav');
  var ocIcon        = $('#oc-icon');
  var ocUtil        = $('#oc-utility');

  pageContainer.css('top', orangeBar + 'px');
  navWrapper.css('top', orangeBar + 'px');
  ocIcon.css('top', (orangeBar + 12) + 'px');
  ocUtil.css('top', orangeBar + 'px');
  
  /*----------  Off Canvas Menu Hide  ----------*/
  var windowWidth = $(window).innerWidth();

  if (windowWidth >= 768) {
    $('.oc-js').removeClass('active');
    $('span.oc-toggle').each(function() {
      // $(this).removeClass('minus').addClass('plus');
      $(this).next('ul').css('display', '');
    });
  } else {
    $(document).trigger('header:mobile-state');
  }
});



window.onscroll = function() {
  var nav = document.getElementById("nav");
  
}
